import { undoConstants } from '../constants';

let nextUndoId = 1;

/**
 * Records a server undo snapshot on the undo stack.
 * No-op when the server reported nothing changed (snapshot is null).
 */
export function pushUndo(label, undo) {
    return (dispatch) => {
        if (!undo) return;
        dispatch({
            type: undoConstants.PUSH_UNDO,
            entry: { id: nextUndoId++, label, undo },
        });
    };
}
